var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app" }, [
    _c("div", { staticClass: "topBox" }, [
      _c("div", { staticStyle: { height: "12px" } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "informationBox" }, [
        _c("div", { staticClass: "Must" }, [_vm._v("必填信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "Requirement" }, [
          _c("div", { staticClass: "letRe fl" }, [_vm._v("卡号")]),
          _vm._v(" "),
          _c("input", {
            staticClass: "rigRe fr",
            attrs: { type: "text", placeholder: "请输入姓名" },
            on: { focus: _vm.focus, blur: _vm.blur }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "Requirement" }, [
          _c("div", { staticClass: "letRe fl" }, [_vm._v("电话")]),
          _vm._v(" "),
          _c("input", {
            staticClass: "rigRe fr",
            attrs: {
              type: "number",
              placeholder: "请输入电话",
              pattern: "[0-9]*"
            },
            on: { focus: _vm.focus, blur: _vm.blur }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "Requirement",
            on: {
              click: function($event) {
                return _vm.clickGender()
              }
            }
          },
          [
            _c("div", { staticClass: "letRe fl" }, [_vm._v("性别")]),
            _vm._v(" "),
            _c("div", { staticClass: "Choice fr" }, [
              _c("i", { staticClass: "iconfont icontiaozhuan fr" }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "fr", staticStyle: { "margin-right": "5px" } },
                [_vm._v(_vm._s(_vm.Gender == true ? "男" : "女"))]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "Requirement", on: { click: _vm.setDate } }, [
          _c("div", { staticClass: "letRe fl" }, [_vm._v("生日")]),
          _vm._v(" "),
          _c("div", { staticClass: "Choice fr" }, [
            _c("i", { staticClass: "iconfont icontiaozhuan fr" }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "fr", staticStyle: { "margin-right": "5px" } },
              [_vm._v(_vm._s(_vm.user))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statementBox" }, [
          _c(
            "div",
            {
              staticClass: "tongyi fl",
              on: {
                click: function($event) {
                  return _vm.clickRead()
                }
              }
            },
            [
              _c("i", {
                staticClass: "iconfont  fl",
                class: [_vm.mark == true ? "iconweixuanzhong" : "iconxuanzhong"]
              }),
              _vm._v("\n              我已阅读并同意\n          ")
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "shiyong fl" }, [
            _vm._v("\n              会员卡使信息使用声明\n          ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "Submission" }, [_vm._v("提交")]),
      _vm._v(" "),
      _c("div", { staticClass: "binding" }, [_vm._v("绑定会员卡")]),
      _vm._v(" "),
      _c("div", { staticClass: "data" }, [
        _vm._v("个人资料将由并仅限雅戈尔使用")
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("div", { staticClass: "port fl" }),
      _vm._v(" "),
      _c("div", { staticClass: "logo_name fl" }, [
        _c("div", [_vm._v("雅戈尔")]),
        _vm._v(" "),
        _c("span", [_vm._v("激活立享会员特权")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "TEL" }, [
        _c("i", { staticClass: "iconfont icontiaozhuan fr" }),
        _vm._v(" "),
        _c("span", { staticClass: "fr" }, [_vm._v("会员卡详情")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5ad3900", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ad3900","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/MemberOpen/index.vue
// module id = null
// module chunks = 